@use '@/styles/tokens' as *;
@use '@/styles/mixins' as *;

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-bottom: var(--space-4);
}

.label {
  padding-inline: var(--space-2);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

// Decorative required marker — rendered via ::after so it stays out of the
// label's accessible name (getByLabelText('Phone Number') still matches).
.requiredLabel::after {
  content: ' *';
  color: $color-error-900;
}

// 110539: a field the design draws with no visible label still needs an accessible name.
.labelHidden {
  @include visually-hidden;
}

.help {
  font-size: 12px;
  color: var(--text-muted);
}

.error {
  font-size: 11px;
  font-weight: 300;
  color: $color-error-900;
}
